import React, { Component } from "react";

// Router
import { Redirect } from "react-router-dom";

// Redux
import { connect } from "react-redux";
import { authLogout } from "../../redux/actions/auth";

class Logout extends Component {
  componentDidMount() {
    this.props.authLogout();
  }

  render() {
    if (!this.props.isAuthenticated) {
      return <Redirect to="/" />;
    } else {
      return null;
    }
  }
}

export default connect(null, { authLogout })(Logout);
